import { LegalLayout } from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Política de Privacidade" lastUpdated="31 de maio de 2026">
      <p>
        Esta Política de Privacidade descreve como a <strong>Naturexpress Produtos
        Alimentícios LTDA</strong>, inscrita no CNPJ sob o nº 61.441.516/0001-66
        (&quot;Naturexpress&quot;, &quot;nós&quot;), coleta, usa, compartilha e protege os dados pessoais dos
        usuários da plataforma disponível em{" "}
        <a href="https://naturexpress.com.br">naturexpress.com.br</a> (&quot;Plataforma&quot;), em
        conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 -
        &quot;LGPD&quot;).
      </p>

      <h2>1. Dados que coletamos</h2>
      <h3>1.1. Dados fornecidos por você</h3>
      <ul>
        <li>
          <strong>Dados de cadastro</strong>: nome, e-mail, telefone, senha (criptografada).
        </li>
        <li>
          <strong>Dados da empresa</strong>: razão social, nome fantasia, CNPJ, endereço
          comercial completo, tipo de operação, nome do contato responsável.
        </li>
        <li>
          <strong>Dados de pedidos</strong>: produtos selecionados, quantidades, janelas de
          entrega, histórico de compras.
        </li>
      </ul>

      <h3>1.2. Dados coletados automaticamente</h3>
      <ul>
        <li>
          <strong>Dados técnicos</strong>: endereço IP, tipo de navegador, sistema
          operacional, identificadores de dispositivo, páginas acessadas e duração da sessão.
        </li>
        <li>
          <strong>Cookies e tecnologias similares</strong>: utilizados para manter sua sessão
          autenticada e melhorar a experiência de uso.
        </li>
      </ul>

      <h3>1.3. Dados recebidos de terceiros</h3>
      <ul>
        <li>
          <strong>Login com Google</strong>: quando você opta por entrar com sua Conta Google,
          recebemos seu nome, e-mail verificado, identificador único Google e foto de perfil,
          conforme os escopos <code>openid</code>, <code>email</code> e <code>profile</code>.
        </li>
        <li>
          <strong>Consulta de CNPJ</strong>: utilizamos serviços públicos (BrasilAPI) para
          validar e preencher automaticamente dados cadastrais a partir do CNPJ informado.
        </li>
      </ul>

      <h2>2. Para que usamos seus dados</h2>
      <ul>
        <li>Criar e gerenciar sua conta na Plataforma.</li>
        <li>Processar e entregar pedidos.</li>
        <li>Vincular você à tabela de preços e janela de entrega adequada.</li>
        <li>Validar seu cadastro comercial e prevenir fraudes.</li>
        <li>Enviar comunicações operacionais (confirmações de pedido, atualizações de entrega).</li>
        <li>Cumprir obrigações legais, fiscais e regulatórias.</li>
        <li>Melhorar a Plataforma por meio de análises agregadas e estatísticas.</li>
      </ul>

      <h2>3. Bases legais para o tratamento</h2>
      <p>
        Tratamos seus dados com base nas seguintes hipóteses previstas na LGPD:
      </p>
      <ul>
        <li><strong>Execução de contrato</strong> (art. 7º, V): para viabilizar o uso da Plataforma e o atendimento aos pedidos.</li>
        <li><strong>Cumprimento de obrigação legal</strong> (art. 7º, II): para atender exigências fiscais e regulatórias.</li>
        <li><strong>Legítimo interesse</strong> (art. 7º, IX): para segurança, prevenção a fraudes e melhoria do serviço.</li>
        <li><strong>Consentimento</strong> (art. 7º, I): quando aplicável, especialmente para comunicações de marketing.</li>
      </ul>

      <h2>4. Compartilhamento de dados</h2>
      <p>Compartilhamos dados apenas com os seguintes destinatários:</p>
      <ul>
        <li><strong>Prestadores de serviço</strong>: provedores de hospedagem, infraestrutura em nuvem, gateway de pagamento e logística de entrega, sob obrigação de confidencialidade.</li>
        <li><strong>Autoridades públicas</strong>: quando exigido por lei, ordem judicial ou requisição de autoridade competente.</li>
        <li><strong>Provedores de autenticação</strong>: Google, quando o login federado é utilizado, exclusivamente para autenticar o acesso.</li>
      </ul>
      <p>Não vendemos seus dados pessoais a terceiros.</p>

      <h2>5. Armazenamento e segurança</h2>
      <p>
        Adotamos medidas técnicas e administrativas razoáveis para proteger seus dados,
        incluindo criptografia em trânsito (HTTPS/TLS), criptografia de senhas (BCrypt),
        controle de acesso baseado em funções e registros de auditoria. Os dados são
        armazenados em servidores localizados no Brasil ou em jurisdições com nível adequado
        de proteção, conforme a LGPD.
      </p>

      <h2>6. Retenção</h2>
      <p>
        Mantemos seus dados pelo tempo necessário para as finalidades descritas nesta
        Política e para o cumprimento de obrigações legais (especialmente prazos fiscais,
        que podem chegar a 5 anos após o encerramento da relação comercial). Após esse
        período, os dados são anonimizados ou eliminados em definitivo.
      </p>

      <h2>7. Seus direitos como titular</h2>
      <p>Nos termos dos arts. 17 e 18 da LGPD, você pode, a qualquer momento:</p>
      <ul>
        <li>Confirmar a existência de tratamento dos seus dados.</li>
        <li>Acessar seus dados e solicitar correção.</li>
        <li>Solicitar anonimização, bloqueio ou eliminação de dados desnecessários.</li>
        <li>Solicitar portabilidade.</li>
        <li>Revogar consentimentos, quando aplicável.</li>
        <li>Opor-se a tratamentos realizados com base no legítimo interesse.</li>
        <li>Apresentar reclamação à Autoridade Nacional de Proteção de Dados (ANPD).</li>
      </ul>
      <p>
        Para exercer qualquer destes direitos, entre em contato com nosso encarregado pelo
        e-mail <a href="mailto:contato@naturexpress.com.br">contato@naturexpress.com.br</a>.
      </p>

      <h2>8. Cookies</h2>
      <p>
        Utilizamos cookies estritamente necessários para o funcionamento da Plataforma
        (autenticação, segurança) e cookies analíticos para entender o uso agregado do
        serviço. Você pode bloquear cookies nas configurações do seu navegador, mas isso
        pode afetar funcionalidades essenciais como o login.
      </p>

      <h2>9. Alterações nesta Política</h2>
      <p>
        Podemos atualizar esta Política periodicamente. A data da última atualização está
        indicada no topo. Mudanças relevantes serão comunicadas por e-mail ou aviso na
        Plataforma.
      </p>

      <h2>10. Contato</h2>
      <p>
        <strong>Naturexpress Produtos Alimentícios LTDA</strong>
        <br />
        CNPJ: 61.441.516/0001-66
        <br />
        Rua das Acácias, 134, Galpão Box 1
        <br />
        Vila Independência — Cariacica/ES
        <br />
        CEP 29148-650
        <br />
        E-mail:{" "}
        <a href="mailto:contato@naturexpress.com.br">contato@naturexpress.com.br</a>
      </p>
    </LegalLayout>
  );
}
